// This file holds all the versioning related information going forward for the app (web/android/ios).
// We use this version information for any version display or console out purposes, used across dev teams, marketing teams to refer the version of app.

// The package json (minor) version should be still incremented before every release(prod), but not for each and every commit into develop.
// The webapp version in this file should have the same major and minor version as in package json version (in sync)
// and the build/patch version(last digit) should be only thing that gets increment for each commit.

// The WEBAPP_VERSION's build/patch should be incremented for every commit along with the LAST_MODIFIED_TIMESTAMP and LAST_MODIFIED_OWNER

// the APP_IOS_VERSION and APP_ANDROID_VERSION versions should be updated in the corresponding app release branches (basing on version generated in ios/android studios)
// and only the updated release branch code should be submitted for store publish

// WEBAPP_VERSION - auto - major/minor version will be always from package.json and auto increment the build/patch version every commit -
// PLEASE DON'T MANUALLY CHANGE IT
const WEBAPP_VERSION = '2.22.286'

// APP_IOS_VERSION - manually updated on ios release branch before publish
const APP_IOS_VERSION = '25.5'

// APP_ANDROID_VERSION - manually updated on android release branch before publish
const APP_ANDROID_VERSION = '35.4'

// LAST_MODIFIED_TIMESTAMP - auto - auto populated based on when we do the commit.
// PLEASE DON'T MANUALLY CHANGE IT
const LAST_MODIFIED_TIMESTAMP = '2026/11/5 12:00'

// LAST_MODIFIED_OWNER - auto - auto populated based on who did the commit.
// PLEASE DON'T MANUALLY CHANGE IT
const LAST_MODIFIED_OWNER = 'Horace Jiang'

module.exports = {
    WEBAPP_VERSION,
    APP_IOS_VERSION,
    APP_ANDROID_VERSION,
    LAST_MODIFIED_TIMESTAMP,
    LAST_MODIFIED_OWNER,
}
